import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RegisterCard from "../../../molecules/RegisterCard";
import AboutInfo from "../../../molecules/AboutInfo";
import AuthLegalLinks from "../../../molecules/AuthLegalLinks";
import MusicalAnimatedBackground from "../../../organisms/Background/MusicalAnimatedBackground/MusicalAnimatedBackground";
import "./index.css";

const RegisterPage = () => {
    const { isLoggedIn } = useSelector(state => state.auth);
    const navigate = useNavigate();

    // Redirect if already logged in
    if (isLoggedIn) {
        navigate("/");
        return null;
    }

    return (
        <div className="register-page">
            <MusicalAnimatedBackground />
            <div className="register-container">
                <RegisterCard />
            </div>
            <AuthLegalLinks />
            <AboutInfo />
        </div>
    );
};

export default RegisterPage;
